
// 

const _makeIdentPrefix = (virtelschemakey) => {
  // NOVO
  // IDENT STANDARD: 10charactera od kojih je prvih 4 STRING a posle njih 6 brojki
  let prefix = '_1__';
  if (virtelschemakey) {
    switch (virtelschemakey) {
      case 'terkk$demper':
        prefix = 'DEM_';
        break;
      case 'terkk$eliminatorkapi':
        prefix = 'ELK_';
        break;
      case 'terkk$spoljnafiksnazaluzina':
        prefix = 'SFZ_';
        break;
      case 'terkk$elasticnaveza':
        prefix = 'ELV_'
        break;
      case 'terkk$panel':
        prefix = 'PAN_';
        break;
      case 'terkk$modul$profilosnovni':
        prefix = 'PRF_';
        break;
      default:
        prefix = '_2__';
    };
  };
  return prefix;
};

export const _makeIdent = (virtelschemakey, integer_id) => {
  // IDENT STANDARD: 10charactera od kojih je prvih 4 STRING a posle njih 6 brojki
  const sest_nula = '000000';
  let ident = _makeIdentPrefix(virtelschemakey) + ((sest_nula) + (integer_id).toString()).slice(-6);
  return ident;
};

